import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const RespirationPage = lazy(() => import("./RespirationPage.tsx"));

const RespirationPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <RespirationPage />
    </Suspense>
  );
};

export default RespirationPageLazy;
